export function returnTotalPages(totalRecords:any,perPage:any){
    return Math.ceil(totalRecords/perPage)
}